import React, { useEffect, useState, memo } from 'react';
import BasicPlan from "./BasicPlan";
import {jobAutomatorPricing, examSimulatorPricing} from "./data.js"
import { useDispatch } from "react-redux";
import { setFetching } from "../../../redux/states"
import {fetchPrice, fetchCurrency } from "../../../utils/client-functions";
import { useErrorSetter } from '../../../hooks/useUiMessages';

const Card = ()=> {
    const dispatch = useDispatch();
    const [pricePerUse, setPricePerUse] = useState(0)
    const [pricePerWeek, setPricePerWeek] = useState(0)
    const [pricePerMonth, setPricePerMonth] = useState(0)

    const [examPriceStudent, setExamPriceStudent] = useState(0)
    const [examPricePro, setExamPricePro] = useState(0)

    const [currency, setCurrency] = useState('')

    const errorSetter = useErrorSetter();

    useEffect(() => {
        dispatch(setFetching(true))
        const fetchData = async () => {
            try {
                // Fetch Job prices
                const j1 = await fetchPrice('resume', 'priceOne')
                const j2 = await fetchPrice('resume', 'priceTwo')
                const j3 = await fetchPrice('resume', 'priceThree')
                setPricePerUse(j1)
                setPricePerWeek(j2)
                setPricePerMonth(j3)

                // Fetch Exam prices
                const eStud = await fetchPrice('exam', 'priceTwo')
                const ePro = await fetchPrice('exam', 'priceThree')
                setExamPriceStudent(eStud)
                setExamPricePro(ePro)


                const userCurrency = await fetchCurrency()
                setCurrency(userCurrency)
            } catch (error) {
                errorSetter('Error fetching country prices, please reload page')
            } finally {
                dispatch(setFetching(false))
            }

        }
        fetchData()
    }, [dispatch])


    const pricingByProduct = {
        "Job Automator": jobAutomatorPricing(pricePerUse, pricePerWeek, pricePerMonth, currency),
        "Exam Simulator": examSimulatorPricing(examPriceStudent, examPricePro, currency),
        "Premium (Everything)": []
    };


    return (
        <>
            <BasicPlan data={pricingByProduct}/>
        </>
    );
}

export default memo(Card);